import { QuestStatus } from 'src/enums/quests';
import theme from 'src/theme';
import { BeehiveHumanReviewStatus } from 'src/types/quests';

export type StatusBadgeColors = {
    color: string;
    backgroundColor: string;
};

export function getQuestStatusColors(status: QuestStatus): StatusBadgeColors {
    switch (status) {
        case QuestStatus.DONE:
            return {
                color: theme.color.brightGreen,
                backgroundColor: theme.color.darkGreenBlack
            };
        case QuestStatus.CANCELLED:
            return {
                color: theme.color.lightRed,
                backgroundColor: theme.color.darkGreyBlack
            };
        case QuestStatus.ON_HOLD:
            return {
                color: theme.color.greenBlue,
                backgroundColor: theme.color.darkGreyBlack
            };
        case QuestStatus.NEW:
            return {
                color: theme.color.turquoise,
                backgroundColor: theme.color.darkGreyBlack
            };
        case QuestStatus.ARCHIVED:
            return {
                color: theme.color.lightGray,
                backgroundColor: theme.color.darkGreyBlack
            };
        case QuestStatus.IN_PROCESS:
            return {
                color: theme.color.chineseGold,
                backgroundColor: theme.color.darkGreyBlack
            };
        case QuestStatus.PLANNING:
            return {
                color: theme.color.bananaYellow,
                backgroundColor: theme.color.darkGreyBlack
            };
        case QuestStatus.DRAFT:
            return {
                color: theme.color.oliveGreen,
                backgroundColor: theme.color.darkGreyBlack
            };
        default:
            return {
                color: theme.color.yellow60,
                backgroundColor: theme.color.darkGreyBlack
            };
    }
}

const BEEHIVE_REVIEW_QUEST_STATUS: Record<
    BeehiveHumanReviewStatus,
    QuestStatus
> = {
    [BeehiveHumanReviewStatus.NOT_SENT]: QuestStatus.NEW,
    [BeehiveHumanReviewStatus.IN_PROGRESS]: QuestStatus.IN_PROCESS,
    [BeehiveHumanReviewStatus.DONE]: QuestStatus.DONE
};

export function getBeehiveHumanReviewStatusColors(
    status: BeehiveHumanReviewStatus
): StatusBadgeColors {
    return getQuestStatusColors(BEEHIVE_REVIEW_QUEST_STATUS[status]);
}
